import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fullRadio", "partialRadio", "amountField", 
    "amountInput", "submitButton"
  ]

  connect() {
    this.toggleAmount()
  }

  toggleAmount() {
    if (this.partialRadioTarget.checked) {
      // Show amount field for partial payment
      this.amountFieldTarget.classList.remove("hidden")
      this.amountInputTarget.required = true
      this.amountInputTarget.focus()
    } else {
      // Hide amount field for full payment
      this.amountFieldTarget.classList.add("hidden")
      this.amountInputTarget.required = false
      this.amountInputTarget.value = ""
    }
  }
}